var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4517 1.57765C15.7518 1.42839 16.0518 1.50302 16.2768 1.72691C16.5019 1.95081 16.5769 2.24933 16.5019 2.62248L9.75107 16.8022C9.60105 17.1007 9.37603 17.25 9.07599 17.25H9.00098C8.70094 17.1754 8.40091 16.9515 8.3259 16.653L6.90073 11.1303L1.35007 9.71235C0.975027 9.63772 0.75 9.3392 0.75 9.04068C0.75 8.74216 0.900018 8.44363 1.20005 8.29437L15.4517 1.57765ZM8.25089 10.3094L9.22601 14.1902L14.1766 3.81656L3.75036 8.74216L7.72583 9.78698C7.95086 9.86161 8.17588 10.0109 8.25089 10.3094Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3361_43764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4517 1.57765C15.7518 1.42839 16.0518 1.50302 16.2768 1.72691C16.5019 1.95081 16.5769 2.24933 16.5019 2.62248L9.75107 16.8022C9.60105 17.1007 9.37603 17.25 9.07599 17.25H9.00098C8.70094 17.1754 8.40091 16.9515 8.3259 16.653L6.90073 11.1303L1.35007 9.71235C0.975027 9.63772 0.75 9.3392 0.75 9.04068C0.75 8.74216 0.900018 8.44363 1.20005 8.29437L15.4517 1.57765ZM8.25089 10.3094L9.22601 14.1902L14.1766 3.81656L3.75036 8.74216L7.72583 9.78698C7.95086 9.86161 8.17588 10.0109 8.25089 10.3094Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3361_43764)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.a8aa0736097c6bbb918001698b594280.svg";
export { ForwardRef as ReactComponent };